<template>
  <!-- 公廁人次 -->
  <div class="col">
    <div class="card card-clean h-100">
      <div class="card-header bg-white border-0 fw-bold text-indigo h5">
        公廁人次
      </div>
      <div class="card-body p-2 text-center">
        <div class="d-flex justify-content-end">
          <button  class="btn btn-dia " style="" @click="showModal()" v-if="!isShortView">
            <i class="fas fa-search-plus"></i>
          </button>
        </div>
        <div style="margin:auto;max-width:450px">
        <apexchart
          v-if="chartSeries"
          type="area"
          :options="chartOptions"
          :series="chartSeries"
        ></apexchart>
      </div>
      <dialog-modal  id="modalPop" ref="objectDetectionDetail" :showUpdateButton="false" :customUpdateButton="false" :modalSize="'xl'"
          :isImage="false" :isMarginAuto="false" :modalTitle="'公廁人次'" :closeButton="false" >
          <div class="object-detection-detail w-75 m-auto" >
                <apexchart
              v-if="chartSeries"
              type="area"
              :options="chartOptions"
              :series="chartSeries"
            ></apexchart>
          </div>
        </dialog-modal>
    </div>

    </div>
  </div>
</template>

<script>
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import DialogModal from "../../components/DialogModal.vue";

import CONST from "../../utils/const";
import Utils from "../../utils/utils";
import { postTolietPeopleFlowInTimeIntervalPerHour } from "../../api/adminDist/ToiletMgtApi";
const zh_tw = require("../../utils/apexchartObject/apexLocales/zh-tw.json");
export default {
  props: ["selectedScenicAreaId"],
  components: {
    apexchart: VueApexCharts,DialogModal
  },
  data() {
    return {
      dataInterval: null,
      viewPort: window.innerWidth,
      isShortView:false,
      toiletData: [],
      chartSeries: [],
      chartOptions: {
        chart: {
          // height: 350,
          zoom: {
            type: "x",
            enabled: true,
            autoScaleYaxis: true,
          },
          defaultLocale: "zh-tw",
          locales: [zh_tw],
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
          width: 3,
        },
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false,
            // format:'HH',
            datetimeFormatter:{
              day: 'MM/dd',
              hour: 'HH',
            }
          },
          tooltip:{
            enabled:false,
          },
          categories: [],
        },
        tooltip: {
          x: {
            format: 'MM/dd  HH',
            formatter:undefined
          },
          y: {
            formatter: function (val) {
              return val + "人";
            },
          },
        },
        legend: {
          showForSingleSeries: true
        },
        stroke: {
          curve: 'smooth',
          width: 1,
        },
        colors: CONST.APEXCHART_COLOR.LINE_CHART_RANGE_FIVE,
        markers: {
          size: 0, // 圓點的大小
          //colors: ["#FF0000"], // 圓點的顏色
          //strokeColors: "#fff", // 圓點的邊框顏色
          strokeWidth: 1, // 圓點邊框的寬度
          hover: {
            size: 1, // 滑鼠懸停時圓點的大小
          },
        },
      },
    };
  },
  methods: {
    showModal(){
      this.$refs.objectDetectionDetail.openModal();
    },
    drawChart() {
      let areaItem = Object.values(this.toiletData.toiletFlowData)[0];

      //console.log(areaItem)
      // let categories = this.toiletData.times;
      //console.log(categories)
      let seriesData = Object.keys(areaItem).map((place) => {
        let result = {};
        result.name = place;
        result.data = areaItem[place];

        // 因未經歷過的時間的並不會回傳人流資料，故則需限制data為24
        //如果 result.data 長度不足 24，使用 0 填補剩餘的部分  Yuan need check (在正式機上檢查是否能成功)
        if (result.data.length < 24) {
          result.data = result.data.concat(Array(24 -result.data.length).fill(0));
        }else{
          result.data = areaItem[place];
        }
        // console.log("result",result.data);
        return result;
      });
      //console.log(seriesData)//
      this.chartSeries = seriesData;
      let newOptions = { ...this.chartOptions };

      const startDate = moment().startOf("day"); // 獲取當天的開始時間，即午夜 00:00
      const dataLength = 24;
      const categories = [];
      for (let i = 0; i < dataLength; i++) {
        const hour = moment(startDate).add(i, "hours").format("HH:mm");
        const date = moment(startDate).format("YYYY-MM-DD");
        const category = `${date} ${hour}`;
        categories.push(category);
      }
      

      newOptions.tooltip.x.formatter = function (val) {
        return `${moment(val).format("MM/DD HH")} - ${moment(val).add(1, 'hours').format("HH")} `;
      };
      newOptions.xaxis.categories = categories;
      newOptions.chart.toolbar.export = {
        csv: {
          filename: `${this.selectedScenicAreaName}_公廁人次_${moment().format(
            "YYYY年MM月DD日_HH時mm分"
          )}`,
        },
        svg: {
          filename: `${this.selectedScenicAreaName}_公廁人次_${moment().format(
            "YYYY年MM月DD日_HH時mm分"
          )}`,
        },
        png: {
          filename: `${this.selectedScenicAreaName}_公廁人次_${moment().format(
            "YYYY年MM月DD日_HH時mm分"
          )}`,
        },
      };
      this.chartOptions = newOptions;
    },
    async GetTolietPeopleFlowInTimeIntervalPerHour() {
      let condition = {
        areas: [this.selectedScenicAreaId],
      // sttime: moment("2023-09-16").startOf("day"),
        // endtime: moment("2023-09-16").endOf("day").subtract(10, "hour"), //測試用切割時間

        sttime:  moment().startOf("day"),
        endtime: moment().startOf("hour"), //取得當日最早時間與當下最近小時
  
      };
      let response = await postTolietPeopleFlowInTimeIntervalPerHour(condition);
      return response.data;
    },
  },
  computed: {
    selectedScenicAreaName() {
      return Utils.getSingleScenicAreaNamebyId(this.selectedScenicAreaId);
    },
  },
  watch: {
    viewPort:{
      handler(newVal){
        if(newVal < 600){
        this.isShortView = true;
      }else{
        this.isShortView = false;
      }},
      immediate: true
    },
    toiletData() {
      this.drawChart();
    },
    async selectedScenicAreaId() {
      this.toiletData = await this.GetTolietPeopleFlowInTimeIntervalPerHour();
    },
  },
  async mounted() {
    this.$_resizeEventHandler = () => {
      this.viewPort = window.innerWidth;
    };
    window.addEventListener('resize', this.$_resizeEventHandler);
    if (this.toiletData?.length == 0) {
      this.toiletData = await this.GetTolietPeopleFlowInTimeIntervalPerHour();
    } else {
      this.drawChart();
    }

    this.dataInterval = setInterval(async () => {
      this.toiletData = await this.GetTolietPeopleFlowInTimeIntervalPerHour();
    }, CONST.REFRESH_DAT_TIMER_MIN);
  },
  destroyed() {
    if (this.dataInterval) clearInterval(this.dataInterval);
    this.dataInterval = null;
  },
};
</script>
